import { specialTopics } from '@prolaera/library/dist';

function getSponsor(cert) {
  if (!cert.sponsors || !cert.sponsors.name) return '';
  return cert.sponsors.name.replace(/,/g, '.');
}

function checkProp(data) {
  if (data) return data.replace(/_/g, '.');
  return '';
}

function getSubjectAreas(cert) {
  let subjectAreas = '';

  if (!cert || !cert.hours || !cert.hours.length) return subjectAreas;

  cert.hours.forEach(({ subject_area, credits }) => {
    if (!subject_area || !credits) return;
    if (subjectAreas.length) subjectAreas += ', ';
    subjectAreas += `${subject_area}: ${credits}`;
  });

  return subjectAreas.replace(/_/g, ' ');
}

function getSpecialTopics(cert) {
  let specialTopicsList = '';

  if (!cert || !cert.hours || !cert.hours.length) return specialTopicsList;

  cert.hours.forEach(hour => {
    specialTopics.forEach(({ name, key, secondary_key }) => {
      if (specialTopicsList.includes(name)) return;

      if (hour[key] || hour[secondary_key]) {
        if (specialTopicsList.length) specialTopicsList += ', ';
        specialTopicsList += `${name}`;
      }
    });
  });

  return specialTopicsList.replace(/_/g, ' ');
}

function generateReport($filter, regulatorDict, regulatorIds, filteredCerts) {
  const headers = [
    'Last Name',
    'First Name',
    'Email',
    'Course Date',
    'Course Name',
    'Course Sponsor',
    'Course Subject Area(s)',
    'Course Special Topic(s)',
    'License',
    'License Category',
    'License Credits'
  ];
  const body = [];
  filteredCerts.filter(({ hours_applied }) => hours_applied).forEach(cert => {
    Object.keys(cert.hours_applied).forEach(regulator => {
      if (regulatorIds && regulatorIds.length && !regulatorIds.includes(regulator)) return;
      Object.keys(cert.hours_applied[regulator]).forEach(category => {
        const reg_id = regulator.slice(0, -5);
        const licenseName = (regulatorDict[reg_id] || {}).name;

        const credits = cert.hours_applied[regulator][category];

        body.push([
          `${checkProp(cert.last)}`,
          `${checkProp(cert.first)}`,
          `${checkProp(cert.email)}`,
          `${checkProp($filter('date')(cert.date, 'shortDate'))}`,
          `${checkProp(cert.cert)}`,
          `${getSponsor(cert)}`,
          `${getSubjectAreas(cert)}`,
          `${getSpecialTopics(cert)}`,
          `${checkProp(licenseName)}`,
          `${checkProp($filter('CategoryName')(category))}`,
          `${credits || 0}`
        ]);
      });
    });
  });

  return { body, headers };
}

export { generateReport };



// WEBPACK FOOTER //
// ./src/app/controllers/users/report/certificate_report.js